import { FC, useState } from "react";
import {
  AdditionalPrice,
  PriceNoteText,
  VerticalDivider,
} from "src/molecules/ProductInfo/ProductInfo.styled";
import { Trans } from "@lingui/macro";
import { Price } from "src/atoms/Price";
import { useTheme, Theme } from "@emotion/react";
import InfoItalicSmall from "src/icons/InfoItalicSmall";
import { PriceInfoWrapper, Button, NoteWrapper } from "./PriceInfo.styled";
import { Text } from "@otrium/atoms";
import { Flex } from "@otrium/core";
import { InfoItalic } from "src/icons";

interface Props {
  regularPrice: number;
  lowestPrice?: number | null;
}

type MessageType = "rrp" | "pp";

const InfoButton: FC<{ onClick: () => void }> = ({ onClick }) => {
  const theme: Theme = useTheme();
  return (
    <Button onClick={onClick} data-testid="product-info-price-info-button">
      <InfoItalicSmall color={theme.colors.tone.anthraciteLight} />
    </Button>
  );
};

const PriceInfo: FC<Props> = ({ regularPrice, lowestPrice }) => {
  const theme: Theme = useTheme();
  const [isMessageVisible, setIsMessageVisible] = useState(false);
  const [messageType, setMessageType] = useState<MessageType>("rrp");

  const handleInfoButtonClick = (newMessageType: MessageType) => {
    if (
      (newMessageType !== messageType && !isMessageVisible) ||
      newMessageType !== messageType
    ) {
      setMessageType(newMessageType);
      setIsMessageVisible(true);
    } else {
      setIsMessageVisible(!isMessageVisible);
    }
  };

  return (
    <PriceInfoWrapper>
      <PriceNoteText>
        <Trans>RRP</Trans>
      </PriceNoteText>
      &nbsp;
      <AdditionalPrice data-testid="product-info-regular-price">
        <Price price={regularPrice} />
      </AdditionalPrice>
      <InfoButton
        onClick={() => {
          handleInfoButtonClick("rrp");
        }}
      />
      {lowestPrice && (
        <>
          <VerticalDivider />
          <PriceNoteText>
            <Trans>PP</Trans>
          </PriceNoteText>
          &nbsp;
          <AdditionalPrice data-testid="product-info-regular-price">
            <Price price={lowestPrice || 0} />
          </AdditionalPrice>
          <InfoButton
            onClick={() => {
              handleInfoButtonClick("pp");
            }}
          />
        </>
      )}
      {isMessageVisible && (
        <NoteWrapper my={3}>
          <Flex variant="centered" mr={2} height={"24px"} minWidth={"24px"}>
            <InfoItalic color={theme.colors.tone.black} />
          </Flex>
          <Text
            color="Black"
            fontSize={0}
            lineHeight={1.43}
            fontWeight="normal"
          >
            {messageType === "rrp" ? (
              <Trans>price_info.rrp</Trans>
            ) : (
              <Trans>price_info.pp</Trans>
            )}
          </Text>
        </NoteWrapper>
      )}
    </PriceInfoWrapper>
  );
};

export default PriceInfo;
